<template>
  <el-dialog
    :title="type === 1 ? '代收批量配置' : '代付批量配置'"
    :visible="visible"
    width="1200px"
    :destroy-on-close="true"
    :lock-scroll="false"
    custom-class="ele-dialog-form"
    @update:visible="updateVisible">
    <el-form :model="form" label-width="0px">
      <el-form-item>
        <el-select
          multiple
          clearable
          filterable
          v-model="form.user_id"
          placeholder="请选择"
          :loading="userLoading"
          class="ele-block"
          @change="handleUserChange">
          <el-option
            v-for="item in userList"
            :key="item.id"
            :value="item.id"
            :label="item.username" />
          <el-option :value="ALL_USER_VALUE" label="全部" class="select-all-option" />
        </el-select>
      </el-form-item>
    </el-form>
    <el-table :data="channelList" v-loading="channelLoading" stripe border>
      <el-table-column label="通道类型" align="center" min-width="120">
        <template slot-scope="scope">
          {{ scope.row.channel_name }}
        </template>
      </el-table-column>
      <el-table-column label="通道列表" align="center" min-width="200">
        <template slot-scope="scope">
          <el-select
            multiple
            filterable
            collapse-tags
            placeholder="请选择"
            v-model="scope.row.channel_id"
            style="width: 100%"
            @change="onChannelChange(scope.row)">
            <el-option :value="ROUND_VALUE" label="轮询" />
            <el-option
              v-for="item in scope.row.channels"
              :key="item.id"
              :value="Number(item.id)"
              :label="item.up_channel_name" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="货币类型" align="center" min-width="160">
        <template slot-scope="scope">
          <el-select
            clearable
            filterable
            v-model="scope.row.cny_id"
            placeholder="请选择"
            style="width: 100%">
            <el-option
              v-for="item in scope.row.cny"
              :key="item.id"
              :value="item.id"
              :label="currencyLabel(item)" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="费率 (%)" align="center" min-width="120">
        <template slot-scope="scope">
          <el-input clearable :maxlength="8" v-model.trim="scope.row.rate" placeholder="请输入">
            <template slot="append">%</template>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column label="手续费 (元)" align="center" min-width="120">
        <template slot-scope="scope">
          <el-input clearable :maxlength="8" v-model.trim="scope.row.fees" placeholder="请输入">
            <template slot="append">元</template>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" min-width="100">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="0"
            active-text="开"
            inactive-text="关" />
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" @click="save" :loading="loading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
const ALL_USER_VALUE = '__ALL__';
const ROUND_VALUE = 0;

export default {
  name: 'ChannelBatchEdit',
  data() {
    return {
      type: 1,
      form: { user_id: [] },
      visible: false,
      loading: false,
      userLoading: false,
      channelLoading: false,
      userList: [],
      channelList: [],
      ALL_USER_VALUE,
      ROUND_VALUE
    };
  },
  methods: {
    currencyLabel(item) {
      if (!item) return '';
      const name = item.cny_name || item.country;
      const code = item.cny_enname;
      return code ? `${name} (${code})` : name;
    },
    handleUserChange(val) {
      if (val.includes(ALL_USER_VALUE)) {
        this.$nextTick(() => {
          this.form.user_id = this.userList.map((item) => item.id);
        });
      }
    },
    onChannelChange(row) {
      const ids = Array.isArray(row.channel_id) ? row.channel_id.map(Number) : [];
      if (!ids.includes(ROUND_VALUE)) {
        return;
      }
      if (ids.length === 1 || ids[ids.length - 1] === ROUND_VALUE) {
        row.channel_id = [ROUND_VALUE];
      } else {
        row.channel_id = ids.filter((id) => id !== ROUND_VALUE);
      }
    },
    openMask(type = 1) {
      this.type = type;
      this.form = { user_id: [] };
      this.visible = true;
      this.loadChannels();
      this.loadUsers();
    },
    loadChannels() {
      this.channelLoading = true;
      const url = this.type === 1 ? '/channeluser/getinUserNoList' : '/channeluser/getoutUserNoList';
      this.$http
        .post(url, { type: this.type })
        .then((res) => {
          this.channelLoading = false;
          if (res.data.code === 0) {
            this.channelList = (res.data.data || []).map((item) => {
              const allIds = (item.channels || []).map((c) => Number(c.id)).filter((id) => id > 0);
              let channelIds = Array.isArray(item.channel_id)
                ? item.channel_id.map((id) => Number(id)).filter((id) => allIds.includes(id))
                : [];
              if (
                !channelIds.length
                || (allIds.length > 0 && channelIds.length === allIds.length
                  && allIds.every((id) => channelIds.includes(id)))
              ) {
                channelIds = [ROUND_VALUE];
              }
              return {
                ...item,
                channel_id: channelIds,
                cny_id: item.cny_id || null,
                rate: item.rate != null ? String(item.rate) : '',
                fees: item.fees != null ? String(item.fees) : '',
                status: item.status || 0
              };
            });
          }
        })
        .catch((e) => {
          this.channelLoading = false;
          this.$message.error(e.message);
        });
    },
    loadUsers() {
      this.userLoading = true;
      this.$http
        .post('/channeluser/getUserList')
        .then((res) => {
          this.userLoading = false;
          if (res.data.code === 0) {
            this.userList = res.data.data || [];
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((e) => {
          this.userLoading = false;
          this.$message.error(e.message);
        });
    },
    save() {
      if (!this.form.user_id.length) {
        this.$message.warning('请选择');
        return;
      }
      const attrArr = this.channelList.map((item) => {
        const selected = Array.isArray(item.channel_id)
          ? item.channel_id.map((id) => Number(id))
          : [];
        const channelIds = (!selected.length || selected.includes(ROUND_VALUE))
          ? []
          : selected.filter((id) => id > 0);
        return {
          channel_type_id: item.id,
          channel_id: channelIds,
          cny_id: item.cny_id || 0,
          rate: item.rate || 0,
          fees: item.fees || 0,
          status: item.status || 0
        };
      });
      this.loading = true;
      this.$http
        .post('/channeluser/saveall', {
          type: this.type,
          user_id: this.form.user_id,
          json: JSON.stringify(attrArr)
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
    },
    updateVisible(val) {
      this.visible = val;
    }
  }
};
</script>

<style scoped>
::v-deep .select-all-option {
  border-top: 1px solid #e4e7ed;
}
</style>
